window.addEventListener("load", function(event) {
    $(".se-pre-con").fadeOut("slow");
    $(".se-pre-con2").fadeOut("slow");
    $('[data-toggle="tooltip"]').tooltip();
});
